<div class="outer-container">

  @if (firstCrumb; as crumb) {
    <div class="first-crumb-container">
      @if (crumb.link) {
        <span class="breadcrumb-link" [routerLink]="crumb.link">{{ crumb.label }}</span>
      } @else {
        <span class="breadcrumb-regular">{{ crumb.label }}</span>
      }
      @if (crumbs?.length > 1) {
        <span class="breadcrumb-regular">&nbsp;&nbsp;&nbsp;&nbsp;&gt;&nbsp;&nbsp;&nbsp;&nbsp;</span>
      }
    </div>
  }

  @if (crumbs?.length > 1) {
    <div class="other-crumbs-container">
      <div class="other-crumbs-inner-container">
        @for (otherCrumb of otherCrumbs; track $index; let idx = $index; let len = $count) {
          @if (otherCrumb.link) {
            <span class="breadcrumb-link" [routerLink]="otherCrumb.link">{{ otherCrumb.label }}</span>
          } @else {
            <span class="breadcrumb-regular">{{ otherCrumb.label }}</span>
          }
          @if (idx < (len - 1)) {
            <span class="breadcrumb-regular">&nbsp;&nbsp;&nbsp;&nbsp;&gt;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          }
        }
      </div>
    </div>
  }

</div>
